import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { TablesDisplayGridRowDataFragmentGql } from './TablesDisplayGridRowDataFragmentGql';

export const WorkbookUpstreamTablesQueryGql: DocumentNode = gql`
query WorkbookUpstreamTablesQuery(
  $workbookVizportalUrlId: String!,
  $first: Int!,
  $offset: Int!,
  $orderBy: DatabaseTableSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  workbooks(filter: { vizportalUrlId: $workbookVizportalUrlId }) {
    upstreamTablesConnection(
      first: $first,
      offset: $offset,
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...TablesDisplayGridRowDataFragment
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${TablesDisplayGridRowDataFragmentGql}
`;
